const NotFound = () => "404 Not found";

export default NotFound;
